import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loadingCount = signal(0);

  /**
   * Computed signal that indicates if any request is currently loading
   */
  isLoading = computed(() => this.loadingCount() > 0);

  /**
   * Computed signal that returns the current number of active requests
   */
  activeRequestsCount = computed(() => this.loadingCount());

  constructor() {}

  /**
   * Starts a loading state by incrementing the loading counter
   */
  startLoading(): void {
    this.loadingCount.update((count) => count + 1);
  }

  /**
   * Stops a loading state by decrementing the loading counter
   * Ensures the counter never goes below 0
   */
  stopLoading(): void {
    this.loadingCount.update((count) => Math.max(0, count - 1));
  }

  /**
   * Resets all loading states to 0
   * Useful for cleanup or error scenarios
   */
  resetLoading(): void {
    this.loadingCount.set(0);
  }

  /**
   * Gets the current loading state as a boolean
   */
  getLoadingState(): boolean {
    return this.loadingCount() > 0;
  }
}
